import { Component, EventEmitter, Output, ChangeDetectionStrategy } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { CustomImageCropper } from "./image-cropper";
import {
  DxButtonModule,
  DxFileUploaderModule,
  DxPopupModule,
} from "devextreme-angular";
import { LogoService } from "src/app/services/logo.service";
import { AppGlobals } from "src/app/app.globals";
import { NgIf } from "@angular/common";

import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
@Component({
    selector: "logo-config",
    imports: [
    GpdButtonComponent,
        DxPopupModule,
        DxButtonModule,
        DxFileUploaderModule,
        CustomImageCropper,
        NgIf,
    ],
    templateUrl: "./logo-config.page.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./logo-config.page.css"]
})
export class LogoConfigComponent {
  @Output() fileSelected = new EventEmitter<File>();
  largeLogo: SafeUrl;
  smallLogo: SafeUrl;

  selectedSmallFile!: File;
  selectedLargeFile!: File;

  smallCropperVisible: boolean = false;
  largeCropperVisible: boolean = false;

  croppingImage: string | null = null;
  croppingTarget: "large" | "small" | null = null;

  searchText: string = $localize`:@@search...:Search...`;

  constructor(private logoService: LogoService) {
    this.loadLogos();
  }

  async onFileSelected(e: any, target: "large" | "small") {
    const file = e.value[0];
    if (!file) return;

    if (target === "large") {
      this.selectedLargeFile = file;
      this.largeCropperVisible = true;
    } else {
      this.selectedSmallFile = file;
      this.smallCropperVisible = true;
    }
  }

  async deleteLogo(target: "large" | "small") {
    if (target === "large" && !this.largeLogo) return;
    if (target === "small" && !this.smallLogo) return;

    let logoIsDefault =
      target === "large"
        ? this.largeLogo == this.logoService.defaultLargeLogo
        : this.smallLogo == this.logoService.defaultSmallLogo;

    if (logoIsDefault) {
      target === "large" ? (this.largeLogo = null) : (this.smallLogo = null);
      return;
    }

    await this.logoService.DeleteLogo(target);

    target === "large" ? (this.largeLogo = null) : (this.smallLogo = null);
    this.emitLogoChangeEvent();
  }

  async loadLogos() {
    let response = await this.logoService.GetLogos();
    if (response.hasError) {
      AppGlobals.ShowErrorMessage(response.feedback);
      return;
    }

    if (response.logos) {
      this.largeLogo = response.logos.largeLogo;
      this.smallLogo = response.logos.smallLogo;
    }
  }

  async saveCroppedImage(blob: Blob, target: "large" | "small") {
    this.largeCropperVisible = false;
    this.selectedSmallFile = null;
    this.smallCropperVisible = false;
    this.selectedLargeFile = null;

    const base64 = await this.blobToBase64(blob);
    const base64Data = base64.split(",")[1];

    const response = await this.logoService.SaveLogo(base64Data, target);

    if (response.hasError) {
      AppGlobals.ShowErrorMessage(response.feedback);
      return;
    }

    if (response.logos) {
      this.smallLogo = response.logos.smallLogo;
      this.largeLogo = response.logos.largeLogo;
    }

    this.emitLogoChangeEvent();
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  emitLogoChangeEvent() {
    this.logoService.eventEmitter.next({
      smallLogo: this.smallLogo,
      largeLogo: this.largeLogo,
    });
  }
}
